<div class="foxi">

  <section class="foxi-hero">
    <img class="foxi-hero__avatar" src="assets/foxi.png" alt="Foxi">
    <div class="foxi-hero__main">
      <h1 class="stk-page-title">Foxi <span class="foxi-hero__tag">MI-munkatárs</span></h1>
      <div class="stk-page-sub">Kérdezz tőle bármit a rendelésekről, a készletről, a ticketekről vagy a csomagokról. Feladatot is adhatsz neki, és ő szól, akinek kell.</div>
      <div class="foxi-hero__status" *ngIf="data">
        <span class="stk-pill" [ngClass]="data.ready ? 'stk-pill--green' : 'stk-pill--yellow'">{{ statusLabel }}</span>
        <span class="foxi-hero__cost" *ngIf="data.hasApiKey">Ma eddig {{ data.todayCostUsd | number:'1.2-2' }} USD<ng-container *ngIf="data.dailyBudgetUsd > 0"> / {{ data.dailyBudgetUsd | number:'1.0-2' }} USD keret</ng-container></span>
      </div>
    </div>
    <a class="stk-btn stk-btn--accent foxi-hero__cta" *ngIf="chatLink" [routerLink]="chatLink">Írj Foxinak 💬</a>
  </section>

  <div class="foxi-empty" *ngIf="loading && !data">Betöltés…</div>
  <div class="foxi-empty" *ngIf="loadFailed">Foxi adatai most nem érhetők el.</div>

  <ng-container *ngIf="data">
    <section class="foxi-card">
      <h2 class="stk-section-title">Mit kérdezhetsz tőle?</h2>
      <div class="foxi-help">Írj neki privátban, vagy szólítsd meg a Fő chatben így: <b>&#64;Foxi</b>. Koppints egy példára a kimásoláshoz.</div>
      <div class="foxi-examples">
        <button type="button" class="foxi-example" *ngFor="let ex of examples" (click)="copy(ex)">{{ ex }}</button>
      </div>
    </section>

    <section class="foxi-card">
      <h2 class="stk-section-title">Időzített feladatok <span class="foxi-count">{{ data.automations.length }}</span></h2>
      <div class="foxi-help" *ngIf="!data.automations.length">Még nincs. Írd meg Foxinak a chatben, mit és mikor csináljon, például: „Minden szerdán 9-kor írj Emesének a dobozokról."</div>

      <div class="foxi-task" *ngFor="let a of data.automations" [class.foxi-task--off]="!a.enabled">
        <div class="foxi-task__top">
          <div class="foxi-task__main" (click)="expanded[a.id] = !expanded[a.id]">
            <div class="foxi-task__title">{{ a.title }}</div>
            <div class="foxi-task__meta">
              <span>🕒 {{ schedule(a.cron) }}</span>
              <span *ngIf="a.ownerName">· {{ a.ownerName }} kérte</span>
              <span *ngIf="a.enabled && a.nextRunAt">· következő: {{ a.nextRunAt | date:'MMM d., EEE HH:mm' }}</span>
              <span *ngIf="!a.enabled">· szünetel</span>
            </div>
          </div>
          <div class="foxi-task__actions" *ngIf="canManage(a)">
            <label class="foxi-switch" [title]="a.enabled ? 'Szüneteltetés' : 'Bekapcsolás'">
              <input type="checkbox" [checked]="a.enabled" [disabled]="busy[a.id]" (change)="toggle(a)">
              <span></span>
            </label>
            <button type="button" class="stk-btn stk-btn--ghost foxi-task__btn" [disabled]="busy[a.id] || !data.ready" (click)="runNow(a)">{{ busy[a.id] ? 'Fut…' : 'Futtatás most' }}</button>
            <button type="button" class="stk-icon-btn foxi-task__del" title="Törlés" (click)="remove(a)">✕</button>
          </div>
        </div>
        <div class="foxi-task__body" *ngIf="expanded[a.id]">
          <div class="stk-label">Utasítás</div>
          <div class="foxi-task__text">{{ a.instruction }}</div>
          <ng-container *ngIf="a.lastResult">
            <div class="stk-label">Utolsó futás · {{ a.lastRunAt | date:'MMM d., HH:mm' }}</div>
            <div class="foxi-task__text foxi-task__text--result">{{ a.lastResult }}</div>
          </ng-container>
        </div>
      </div>
    </section>

    <section class="foxi-card">
      <h2 class="stk-section-title">Amit Foxi megjegyzett <span class="foxi-count">{{ data.memories.length }}</span></h2>
      <div class="foxi-help" *ngIf="!data.memories.length">Még semmi. Ha azt írod neki, hogy „jegyezd meg…", ide kerül, és minden beszélgetésben emlékezni fog rá.</div>
      <div class="foxi-memory" *ngFor="let m of data.memories">
        <span class="foxi-memory__text">{{ m.text }}</span>
        <button type="button" class="stk-icon-btn foxi-memory__del" title="Elfelejteni" (click)="forget(m.id)">✕</button>
      </div>
    </section>
  </ng-container>
</div>
